<template>
    <modal-cadu
        close
        :width="1131.52"
        v-model="show"
    >
        <div slot="all" class="pt-10 pb-4 px-10">
            <div slot="header">
                <div class="font-secundaria headline font-weight-bold pb-4" style="color: #00995D">
                    VISUALIZAR USUÁRIO
                </div>
            </div>
            <div slot="body">
                <v-row>
                    <v-col cols="12" sm="12" md="6">
                        <v-row>
                            <v-col cols="12" sm="12" md="11">
                                <input-cadu
                                    title="Unimed"
                                    v-model="unimed"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" sm="12" md="7">
                                <input-cadu
                                    title="Login"
                                    v-model="login"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" sm="12" md="11">
                                <input-cadu
                                    title="Área"
                                    v-model="area"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" sm="12" md="12">
                                <input-cadu
                                    title="E-mail Corporativo"
                                    v-model="email"
                                    :onlyUpperCase="false"
                                    disabled
                                />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-row>
                            <v-col cols="12" sm="12" md="12">
                                <input-cadu
                                    title="Nome Colaborador"
                                    v-model="nomeColaborador"
                                    disabled
                                />
                            </v-col>
                            <v-col cols="12" sm="12" md="6">
                                <input-cadu
                                    title="Perfil"
                                    v-model="perfil"
                                    disabled
                                />
                            </v-col>
                            <v-row class="px-3">
                                <v-col cols="12" sm="12" md="6">
                                    <input-cadu
                                        title="Cargo"
                                        v-model="cargo"
                                        disabled
                                    />
                                </v-col>
                                <v-col cols="12" sm="12" md="6">
                                    <v-row justify="end" no-gutters>
                                        <v-col cols="12" sm="12" md="8">
                                            <input-cadu
                                                v-mask="telefoneMask"
                                                title="Telefone"
                                                v-model="telefone"
                                                disabled
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-col cols="7" sm="7" md="7">
                                    <v-row justify="end" no-gutters>
                                        <v-col cols="12" sm="12" md="12">
                                            <input-cadu
                                                title="Data do Último Acesso"
                                                v-model="dataUltimoAcesso"
                                                disabled
                                            />
                                        </v-col>
                                    </v-row>
                                </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </div>
            <div slot="footer" class="pt-6">
                <v-row justify="end">
                    <v-col cols="auto">
                        <button-cadu @click="$emit('input', false)">
                            VOLTAR
                        </button-cadu>
                    </v-col>
                </v-row>
            </div>
        </div>
    </modal-cadu>
</template>

<script>
import { mask } from 'vue-the-mask'
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  directives: {
    mask
  },
  data () {
    return {
      show: this.value,
      unimed: '',
      login: '',
      area: '',
      email: '',
      nomeColaborador: '',
      perfil: '',
      cargo: '',
      telefone: '',
      dataUltimoAcesso: '',
      telefoneMask: '(##) ####-####'
    }
  },
  methods: {
    start (obj) {
      this.unimed = obj.unimed ? obj.unimed.nomeCompleto : ''
      this.login = obj.login || ''
      this.area = obj.tipoArea ? obj.tipoArea.nome : ''
      this.email = obj.emailCorporativo || ''
      this.nomeColaborador = obj.nome || ''
      this.perfil = obj.papel || ''
      this.cargo = obj.cargo ? obj.cargo.nome : ''
      this.telefone = obj.telefoneCorporativo || ''
      this.dataUltimoAcesso = obj.dataUltimoAcesso ? obj.dataUltimoAcesso : ''
    }
  },
  watch: {
    value () {
      this.show = this.value
    },
    show () {
      this.$emit('input', this.show)
    }
  }
}
</script>

<style>

</style>
